module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day02_02_stay-4211230784f7527348494dca1997640b.jpg";